import { useState, useCallback, useEffect, useMemo } from 'react'
import { HereResult } from '@user/store/services/hereGeoCoder'
import { geocode } from '@user/Root'
import * as _ from 'lodash'

export const useGeocode = (debounceDelay: number = 500) => {
  const [query, setQuery] = useState<string>()
  const [result, setResult] = useState<HereResult>()

  const execute = useCallback(
    (query: string) => query.trim() != '' && setQuery(query.trim()),
    [],
  )

  const fetch = useMemo(
    () =>
      _.debounce(
        (
          search: string,
          geolocation: string,
          callback: (results?: HereResult[]) => void,
        ) => geocode(search, geolocation, callback),
        debounceDelay,
      ),
    [debounceDelay],
  )

  useEffect(() => {
    let mounted = true

    if (!!query && query.length > 0) {
      fetch(query, '', (results?: HereResult[]) => {
        if (mounted) {
          setResult(results?.shift())
          setQuery(undefined)
        }
      })
    }

    return () => {
      mounted = false
    }
  }, [fetch, query])

  return { result, execute }
}
